<template>
  <div
    class="mt-6 section-buttons"
    style="margin-bottom: -12px;"
    v-if="buttons && buttonArr.length"
  >
    <v-btn
      class="section-button"
      v-for="(button, index) in buttonArr"
      :key="index"
      :to="
        getLinkType(button['button-link']) == 'page'
          ? button['button-link']
          : null
      "
      :href="
        getLinkType(button['button-link']) == 'url'
          ? button['button-link']
          : null
      "
      :target="getLinkType(button['button-link']) == 'url' ? '_blank' : ''"
      @click="clicked(button['button-link'])"
      v-bind="buttonProps(button)"
    >
      {{ button['button-text'] }}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'ContentButtons',
  props: {
    buttons: {
      type: String,
      nullable: true
    }
  },
  computed: {
    buttonArr() {
      return this.buttons ? JSON.parse(this.buttons) : []
    }
  },
  methods: {
    getLinkType(link) {
      let linkArr = link.split('/')

      if (linkArr[0] == 'https:' || linkArr[0] == 'http:') {
        return 'url'
      }

      if (linkArr[0][0] == '#') {
        return 'section'
      }

      if (!linkArr[0] && linkArr[1]) {
        if (linkArr[1][0] == '#') {
          return 'section'
        } else {
          return 'page'
        }
      }

      return 'page'
    },
    buttonTextColor(button) {
      let color = button['button-text-color']

      if (
        button['button-style'] === 'default' &&
        button['button-text-color'] === 'inherit'
      ) {
        if (button['button-background-color'] === 'var(--primary-color)') {
          let defaultColor = getComputedStyle(
            document.documentElement
          ).getPropertyValue('--primary-text-color')

          color = `var(--text-${defaultColor}-color)`
        } else if (
          button['button-background-color'] === 'var(--secondary-color)'
        ) {
          let defaultColor = getComputedStyle(
            document.documentElement
          ).getPropertyValue('--secondary-text-color')

          color = `var(--text-${defaultColor}-color)`
        }
      }

      return color
    },
    buttonProps(button) {
      return {
        class: ['mb-3'],
        depressed: true,
        outlined: button['button-style'] == 'outlined',
        text: button['button-style'] == 'text',
        color:
          button['button-style'] == 'text'
            ? 'transparent'
            : button['button-background-color'],
        style: {
          color: this.buttonTextColor(button),
          borderColor: button['button-background-color']
        }
      }
    },
    clicked(link) {
      if (
        this.getLinkType(link) == 'section' &&
        document.getElementById(link.replace('#', '').replace('/', ''))
      ) {
        this.$vuetify.goTo(link, {
          offset: this.$store.state.section.stickyHeader.height
        })
      }
    }
  }
}
</script>

<style scoped>
.section-buttons {
  margin-left: -6px;
  margin-right: -6px;
}

.section-button {
  margin-left: 6px;
  margin-right: 6px;
}
</style>
